import { groq } from 'next-sanity';
import { z } from 'zod';

import { form, SanityForm } from './form';
import { link, SanityLink } from './link';

export const SanityHeroHome = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('heroHome'),
  _key: z.string(),
  title: z.string(),
  subtitle: z.string().optional().nullable(),
  form: SanityForm.optional().nullable(),
  formFunnel: z.enum(['contact', 'rails']),
  primaryButtonLabel: z.string(),
  formConfirmation: z.string().optional().nullable(),
  secondaryButton: SanityLink.optional().nullable(),
  subtextLink: SanityLink.optional().nullable(),
  mascot: z
    .enum([
      'none',
      'peek-teal-ul-then-lime-lr',
      'peek-lime-lr',
      'peek-purple-ll',
      'bounce-teal-bottom-to-cta',
      'roll-purple-bottom',
      'peek-purple-ul-then-teal-lc',
    ])
    .optional()
    .nullable(),
});
export type SanityHeroHome = z.infer<typeof SanityHeroHome>;

export const heroHome = groq`{
  title,
  subtitle,
  form -> ${form},
  "formFunnel": coalesce(formFunnel, "contact"),
  "primaryButtonLabel": coalesce(primaryButtonLabel, "Get a demo"),
  formConfirmation,
  secondaryButton[0] ${link},
  subtextLink[0] ${link},
  'mascot': coalesce(mascot, 'none'),
}`;
